
import { Box, Container, Grid, Typography, IconButton, Divider, Button, Link } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailIcon from '@mui/icons-material/Mail';

export default function Footer() {
  return (
    <Box sx={{ backgroundColor: '#2e2e2e', color: 'white', py: 4, mt: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          {/* Sponsors Section on the Left */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              This project is co-financed by:
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
              <img src="prr-branco.png" alt="Sponsor 1" style={{ width: '120px', height: '50px' }} />
              <img src="rp-branco.png" alt="Sponsor 2" style={{ width: '120px', height: '50px' }} />
              <img src="NextGenerationEU_logo-branco.png" alt="Sponsor 3" style={{ width: '120px', height: '40px' }} />
              <img src="ani-branco.png" alt="Sponsor 4" style={{ width: '120px', height: '40px' }} />
              <img src="MissaoInterface_LOGO-branco.png" alt="Sponsor 5" style={{ width: '120px', height: '40px' }} />
            </Box>
          </Grid>

          {/* Follow Us Section on the Right */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Follow Us!
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <IconButton
                href="https://www.facebook.com/colab4food"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href="https://www.instagram.com/colab4food/"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                href="https://www.linkedin.com/company/colab4food/"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon />
              </IconButton>
            </Box>

            {/* Botão "Get in Loop" abaixo dos ícones em Follow Us */}
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<MailIcon />}
                href="/contacts"
                sx={{
                  backgroundColor: '#ff4081',
                  '&:hover': {
                    backgroundColor: '#e1005e',
                  },
                }}
              >
                Contact Us
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Linha horizontal separando as seções */}
        <Divider sx={{ my: 4, backgroundColor: '#ffffff' }} />

        {/* Espaço maior entre as seções */}
        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography variant="body2" color="inherit" align="center">
            Proprietary Platform - Copyright 2025 by Colab4Food. Hub4Food<sup>® </sup> and Colab4Food<sup>® </sup> are registered trademarks. All rights reserved.
          </Typography>
          {/* Links para as políticas */}
          <Typography variant="body2" color="inherit" align="center" sx={{ mt: 2 }}>
            <Link href="/comingsoon" color="inherit" sx={{ mx: 1 }}>
              Privacy Policy
            </Link>
            |
            <Link href="/comingsoon" color="inherit" sx={{ mx: 1 }}>
              Terms & Conditions
            </Link>
            |
            <Link href="/comingsoon" color="inherit" sx={{ mx: 1 }}>
              Accessibility Statement
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}